import { render } from "./RoomSummary.vue?vue&type=template&id=d685f890&ts=true"
import script from "./RoomSummary.vue?vue&type=script&lang=ts"
export * from "./RoomSummary.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__